import { useTranslation } from 'react-i18next';
import { AccountsFilter } from '../../Accounts';

export const PartnersFilter = () => {
  const { t } = useTranslation();

  return <AccountsFilter keywordPlaceholder={t<string>('Search.PartnerFilterPlaceholder')} domain="partner" />;
};
